import type { LabelPreviewData } from '@/types/label-template';

/** Демо-значения для редактора этикеток (не реальные КИЗ/товары). */
export const DESIGNER_PREVIEW_DEFAULT_LABEL: LabelPreviewData['label'] = {
  name: 'Демо · Футболка хлопок',
  brand: 'DEMO BRAND',
  article: 'ART-00042',
  sellerArticle: 'SELLER-42',
  color: 'Синий',
  size: 'L',
  techSize: '50',
  gtin: '04600000000001',
  serial: '5qyDQsEmMYmF1',
  barcode: '4600000000001',
  number: '000001',
  composition: '100% хлопок',
  country: 'Россия',
  manufacturer: 'ООО «Демо Производство»',
  manufactureDate: '01.01.2026',
  sellerName: 'ООО «Демо Продавец»',
  sellerShortName: 'Демо Продавец',
  userId: 'demo-user',
  shortAddress: 'г. Москва, ул. Примерная, д. 1',
  address: 'RU, Moscow, Primernaya st., 1',
  storageGroup: '—',
};

export function fillEmptyLabelFields(
  label: LabelPreviewData['label'],
  defaults: LabelPreviewData['label'] = DESIGNER_PREVIEW_DEFAULT_LABEL,
): LabelPreviewData['label'] {
  const next = { ...label };
  for (const key of Object.keys(defaults) as Array<keyof LabelPreviewData['label']>) {
    const cur = String(next[key] ?? '').trim();
    if (!cur) next[key] = defaults[key];
  }
  return next;
}
